import { get } from 'data/services/apiService';
import { API_URL } from 'data/services/apiConstants';

import { addPropertyIdToComplianceDates } from 'utils/complianceDatesUtils'

const GET_COMPLIANCE_DATES_PORTFOLIO_REQUEST = 'GET_COMPLIANCE_DATES_PORTFOLIO_REQUEST';
const GET_COMPLIANCE_DATES_PORTFOLIO_SUCCESS = 'GET_COMPLIANCE_DATES_PORTFOLIO_SUCCESS';
const GET_COMPLIANCE_DATES_PORTFOLIO_ERROR = 'GET_COMPLIANCE_DATES_PORTFOLIO_ERROR';

const initialState = {
	data: null,
	isLoading: false,
	hasError: false,
	error: null,
};


export const getPortfolioComplianceDates = () => (dispatch, getState) => {
	const state = getState();
	const url = `${API_URL}/api/properties/compliance-dates`;
	dispatch(getComplianceDatesRequest());

	return get({
		dispatch,
		url,
		authToken: state.user.authToken,
		onSuccess: (result) => {
			dispatch(getComplianceDatesRequestSuccess(result))
		},
		onError: error => dispatch(getComplianceDatesRequestError(error)),
	});
};

export const getPropertyComplianceDates = (propertyId) => (dispatch, getState) => {
	// const state = getState();
	const url = `${API_URL}/api/properties/compliance-dates?propertyIds=${propertyId}`;
	dispatch(getComplianceDatesRequest());

	return get({
		dispatch,
		url,
		// authToken: state.user.authToken,
		onSuccess: (result) => {
			dispatch(getComplianceDatesRequestSuccess(result))
		},
		onError: error => dispatch(getComplianceDatesRequestError(error)),
	});
};

export const getComplianceDatesRequest = (propertyId) => ({
	type: GET_COMPLIANCE_DATES_PORTFOLIO_REQUEST,
	payload: {
		propertyId,
		isLoading: true,
		data: null,
	}
});

export const getComplianceDatesRequestSuccess = (data) => {
	let dates = addPropertyIdToComplianceDates(data);
	return ({
		type: GET_COMPLIANCE_DATES_PORTFOLIO_SUCCESS,
		payload: {
			isLoading: false,
			hasError: false,
			data: dates,
			error: null,
		}
	});
};

export const getComplianceDatesRequestError = (error) => ({
	type: GET_COMPLIANCE_DATES_PORTFOLIO_ERROR,
	payload: {
		isLoading: false,
		data: null,
		hasError: true,
		error: error,
	}
});

const complianceDatesReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_COMPLIANCE_DATES_PORTFOLIO_REQUEST:
		case GET_COMPLIANCE_DATES_PORTFOLIO_SUCCESS:
		case GET_COMPLIANCE_DATES_PORTFOLIO_ERROR:
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
};

export default complianceDatesReducer;
